"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const swiper_1 = __importDefault(require("../helpers/swiper/swiper"));
/**
  * Media gallery swiper
  *
  * @param {HTMLElement} el - js-media-carousel
  * @returns {void}
  *
  * @example
  * <div class="section-media-carousel js-media-carousel js-media-carousel-0" data-swiper-index="0">
  *  <div class="swiper-container js-swiper-container">
  *   <div class="swiper-wrapper">
  *
  *    <div class="swiper-slide">
  *     <img src="image.jpg" alt="Image">
  *    </div>
  *    <div class="swiper-slide">
  *     <video src="video.mp4" tabindex="-1"></video>
  *     <div class="section-media-carousel__video_overlay"></div>
  *    </div>
  *
  *   </div>
  *  </div>
  *
  *  <button class="swiper-button-prev js-swiper-prev-0" aria-label="Previous slide"></button>
  *  <button class="swiper-button-next js-swiper-next-0" aria-label="Next slide"></button>
  *  <div class="swiper-pagination js-swiper-pagination-0"></div>
  * </div>
  *
 */
const mediaCarousel = {
    swiper: null,
    paginationSeparator: ' / ',
    swiperIndex: 0,
    initMediaCarousel(el) {
        console.log('Init mediaCarousel');
        this.el = el;
        this.swiperEl = el.querySelector('.js-swiper-container');
        const settings = window.mediaGallerySettings || {};
        if (settings) {
            this.paginationSeparator = settings.paginationSeparator;
        }
        if (el.dataset.swiperIndex) {
            this.swiperIndex = parseInt(el.dataset.swiperIndex);
        }
        if (this.swiperEl) {
            const self = this;
            const swiper = new swiper_1.default(this.swiperEl, {
                speed: 500,
                allowTouchMove: true,
                keyboard: true,
                watchSlidesProgress: true,
                slidesPerView: "auto",
                loop: false,
                slideToClickedSlide: true,
                effect: el.dataset.effect || 'slide',
                simulateTouch: true,
                preventClicksPropagation: false,
                preventClicks: true,
                navigation: {
                    nextEl: `.js-swiper-next-${self.swiperIndex}`,
                    prevEl: `.js-swiper-prev-${self.swiperIndex}`
                },
                pagination: {
                    el: `.js-swiper-pagination-${self.swiperIndex}`,
                    type: 'custom',
                    renderCustom: function (_, current, total) {
                        return current + self.paginationSeparator + total;
                    }
                },
                a11y: {
                    prevSlideMessage: settings.prevHelperText,
                    nextSlideMessage: settings.nextHelperText,
                },
                breakpoints: {
                    // when window width is >= 1056px disable touch swipe
                    1056: {
                        allowTouchMove: false,
                        slideToClickedSlide: !!el.dataset.preventClickDeskop ? false : true
                    },
                },
                on: {
                    slideChangeTransitionEnd(_) {
                        const videos = el.querySelectorAll('video');
                        Array.prototype.forEach.call(videos, function (video) {
                            video.pause();
                            const parent = video.closest('.swiper-slide');
                            const overlay = parent.querySelectorAll('.video__overlay');
                            if (video.getAttribute('tabindex') === '-1' && parent.classList.contains('swiper-slide-active')) {
                                video.setAttribute('tabindex', '0');
                                // logic for overlay
                                if (overlay.length) {
                                    overlay.forEach(ol => ol.classList.add('js-video-active'));
                                }
                            }
                            else if (video.getAttribute('tabindex') === '0') {
                                video.setAttribute('tabindex', '-1');
                                if (overlay.length) {
                                    overlay.forEach(ol => ol.classList.remove('js-video-active'));
                                }
                            }
                        });
                    },
                }
            });
        }
    }
};
exports.default = mediaCarousel;
